import { FunctionComponent, MouseEvent } from 'react';
import { BodyText, Div, Gutter, InlineNotification, Link, Span } from '@gaiads/telia-react-component-library';
import { Trans, useTranslation } from 'react-i18next';

interface DeviceLimitFullNotificationProps {
  closeOnClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const DeviceLimitFullNotification: FunctionComponent<DeviceLimitFullNotificationProps> = ({ closeOnClick }) => {
  const { t } = useTranslation('product');

  return (
    <InlineNotification variant="information" title={t('DeviceLimitFullNotification.title')} closeOnClick={closeOnClick}>
      <Div>
        <BodyText size={'sm'} color={'gray500'}>
          {t('DeviceLimitFullNotification.paragraph1')}
        </BodyText>
        <Gutter size={'sm'} />
        <BodyText size={'sm'} color={'gray500'}>
          <Trans
            t={t}
            i18nKey="DeviceLimitFullNotification.paragraph2"
            components={{
              strong: <strong />,
              a: <Link to={'/myassets'} />,
              span: <Span color={'gray500'} fontWeight={'medium'} />,
            }}
          ></Trans>
        </BodyText>
        <Gutter size={'sm'} />
      </Div>
    </InlineNotification>
  );
};

export default DeviceLimitFullNotification;
